import React from "react";
import { useTranslation } from "react-i18next";
import Button from "../../atoms/Button/Button.component";
import AnalystDemo from "../../molecules/AnalystDemo/AnalystDemo.component";
import { TENDBE_APP_URL } from "../../../constants/navigation";
import { trustedPartners } from "../../../constants/trusted-partners";
import { newLineText } from "../../../utils/utils";
import {
  HeroActions,
  HeroCopy,
  HeroGrid,
  HeroNote,
  HeroShell,
  HeroSubhead,
  HeroTitle,
  LogoCropImage,
  LogoCropWindow,
  PartnerLogoLink,
  PartnerLogos,
  ProductWrap,
  StripLabel,
  TrustBar,
  TrustBarInner,
} from "./LandingHero.styled";

const LandingHero = () => {
  const { t } = useTranslation();

  return (
    <>
      <HeroShell>
        <HeroGrid as="section" aria-labelledby="hero-title">
          <HeroCopy>
            <HeroTitle id="hero-title">
              {newLineText(t("landing.hero.title")).map((line) => (
                <span key={line}>{line}</span>
              ))}
              {newLineText(t("landing.hero.titleAccent")).map((line) => (
                <span className="accent" key={line}>
                  {line}
                </span>
              ))}
            </HeroTitle>
            <HeroSubhead>{t("landing.hero.subhead")}</HeroSubhead>
            <HeroActions>
              <Button href={TENDBE_APP_URL}>
                {t("landing.hero.startFree")}
              </Button>
            </HeroActions>
            <HeroNote>
              <strong>{t("landing.hero.noteStrong")}</strong>{" "}
              {t("landing.hero.noteLine1")}
              <br />
              <strong>{t("landing.hero.noteStrong2")}</strong>
            </HeroNote>
          </HeroCopy>
          <ProductWrap id="analyst">
            <AnalystDemo />
          </ProductWrap>
        </HeroGrid>
      </HeroShell>
      <TrustBar aria-label={t("landing.strip.label")}>
        {/* Marks where the hero ends, so the sticky header knows when to
         * switch from its full-size hero styling to the compact bar. */}
        <span id="hero-sentinel" aria-hidden="true" style={{ display: "block", height: 0 }} />
        <TrustBarInner>
          <StripLabel>
            {newLineText(t("landing.strip.label")).map((line) => (
              <span key={line}>{line}</span>
            ))}
          </StripLabel>
          <PartnerLogos>
            {trustedPartners.map((partner) => (
              <PartnerLogoLink
                key={partner.name}
                href={partner.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                <LogoCropWindow
                  style={{ width: `${partner.crop.windowWidth}px` }}
                >
                  <LogoCropImage
                    src={partner.src}
                    alt={partner.name}
                    style={{
                      width: `${partner.crop.imgWidth}px`,
                      height: `${partner.crop.imgHeight}px`,
                      transform: `translate(${partner.crop.offsetX}px, ${partner.crop.offsetY}px)`,
                    }}
                  />
                </LogoCropWindow>
              </PartnerLogoLink>
            ))}
          </PartnerLogos>
        </TrustBarInner>
      </TrustBar>
    </>
  );
};

export default LandingHero;
